export const REST_API_ENDPOINT = 'https://youtube-night.herokuapp.com/';
